const projectDocument = [
  {
      icon: "ri-folder-zip-line",
      icon_color: "secondary",
      name: 'Artboard-documents.zip',
      type: 'Zip',
      size: '4.57',
      date: '12 Dec 2021',
  },
  {
    icon: "ri-file-pdf-fill",
    icon_color: "danger",
    name: 'Bank Management System',
    type: 'PDF',
    size: '8.89',
    date: '24 Nov 2021',
  },
  {
    icon: "ri-video-line",
    icon_color: "secondary",
    name: 'Tour-video.mp4',
    type: 'MP4',
    size: '14.62',
    date: '19 Nov 2021',
  },
  {
    icon: "ri-file-excel-fill",
    icon_color: "success",
    name: 'Account-statement.xsl',
    type: 'XSL',
    size: '2.38',
    date: '14 Nov 2021',
  },
  {
    icon: "ri-folder-fill",
    icon_color: "warning",
    name: 'Project Screenshots Collection',
    type: 'Floder',
    size: '87.24',
    date: '08 Nov 2021',
  },
  {
    icon: "ri-image-2-fill",
    icon_color: "danger",
    name: 'Velzon-logo.png',
    type: 'PNG',
    size: '879',
    date: '02 Nov 2021',
  }
];

const ProjectTeam = [
  {
    id:'1',
    image: 'assets/images/users/avatar-2.jpg',
    bg_color: '',
    name: 'Nancy Martino',
    position: 'Team Leader & HR',
    projects: '225',
    tasks: '197',
    star: '',
  },
  {
    id:'2',
    image: '',
    bg_color: 'danger',
    name: 'Henry Baird',
    position: 'Full Stack Developer',
    projects: '352',
    tasks: '376',
    star: 'active',
  },
  {
    id:'3',
    image: 'assets/images/users/avatar-3.jpg',
    bg_color: '',
    name: 'Frank Hook',
    position: 'Project Manager',
    projects: '164',
    tasks: '182',
    star: 'active',
  },
  {
    id:'4',
    image: 'assets/images/users/avatar-8.jpg',
    bg_color: '',
    name: 'Jennifer Carter',
    position: 'UI/UX Designer',
    projects: '225',
    tasks: '197',
    star: '',
  },
  {
    id:'5',
    image: '',
    bg_color: 'success',
    name: 'Megan Elmore',
    position: 'Team Leader & Web Developer',
    projects: '201',
    tasks: '263',
    star: '',
  },
  {
    id:'6',
    image: 'assets/images/users/avatar-4.jpg',
    bg_color: '',
    name: 'Alexis Clarke',
    position: 'Backend Developer',
    projects: '132',
    tasks: '147',
    star: '',
  },
  {
    id:'7',
    image: '',
    bg_color: 'info',
    name: 'Nathan Cole',
    position: 'Front-End Developer',
    projects: '352',
    tasks: '376',
    star: '',
  },
  {
    id:'8',
    image: '',
    bg_color: 'info',
    name: 'Nathan Cole',
    position: 'Front-End Developer',
    projects: '352',
    tasks: '376',
    star: '',
  },
  {
    id:'9',
    image: 'assets/images/users/avatar-7.jpg',
    bg_color: '',
    name: 'Joseph Parker',
    position: 'Team Leader & HR',
    projects: '64',
    tasks: '93',
    star: '',
  },
  {
    id:'10',
    image: 'assets/images/users/avatar-5.jpg',
    bg_color: '',
    name: 'Erica Kernan',
    position: 'Web Designer',
    projects: '345',
    tasks: '298',
    star: '',
  },
  {
    id:'11',
    image: '',
    bg_color: 'primary',
    name: 'Donald Palmer',
    position: 'Wed Developer',
    projects: '97',
    tasks: '135',
    star: '',
  },
];


export { projectDocument, ProjectTeam };
